module.exports = __webpack_public_path__ + "static/helen_portrait-b6214fdae2cb811840446605006a9523.jpg";